<jml-lib-entity-view
  *ngIf="userId$ | async as userId"
  configName="UserProfile"
  [entryId]="userId"
></jml-lib-entity-view>
